import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd61a52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price__wrapper" }
const _hoisted_2 = { class: "product__price-info" }
const _hoisted_3 = { class: "product__prices" }
const _hoisted_4 = {
  key: 0,
  class: "product__price--fix"
}
const _hoisted_5 = { class: "product__stock" }
const _hoisted_6 = { class: "product__buttons" }

import { IProduct } from '@/services';
import { toRefs, reactive, computed } from 'vue';
import { useCart, useModal } from '@/store';
import router from '@/router';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPrice',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { product } = reactive(props);
const { id, price, actualPrice, discountPercentage, stock } = toRefs(product);
const { addProduct, dropProduct, findProduct } = useCart();
const { modalIsShow } = storeToRefs(useModal());

const buttonStatus = computed((): { name: string; icon: string } => {
  return findProduct(id.value)
    ? { name: 'Drop from cart', icon: 'icon-cart-ok' }
    : { name: 'Add to cart', icon: 'icon-cart-plus' };
});

const updateCart = (): void => {
  findProduct(id.value) ? dropProduct(id.value) : addProduct(product);
};

const fastBuy = (): void => {
  router.push({ name: 'cart' });
  modalIsShow.value = true;
  addProduct(product);
  document.body.style.overflow = 'hidden';
};

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(discountPercentage))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createTextVNode(" $"),
              _createVNode(_component_AppNumber, {
                input: _unref(price),
                fixed: 2
              }, null, 8 /* PROPS */, ["input"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", {
          class: _normalizeClass([{ crossed: _unref(discountPercentage) }, "product__price--full"])
        }, [
          _createTextVNode(" $"),
          _createVNode(_component_AppNumber, {
            input: _unref(actualPrice),
            fixed: 2
          }, null, 8 /* PROPS */, ["input"])
        ], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_5, "Left in stock: " + _toDisplayString(_unref(stock)) + "pc.", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppButton, {
          class: "button__cart",
          onClick: updateCart
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["button__cart--icon", _unref(buttonStatus).icon])
            }, null, 2 /* CLASS */),
            _createTextVNode(" " + _toDisplayString(_unref(buttonStatus).name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_AppButton, {
          class: "button__fast-buy",
          onClickPassive: fastBuy
        }, {
          default: _withCtx(() => [
            _createTextVNode("Buy")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}
}

})